/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createHttpValidationProblemDetailsFromDiscriminatorValue, createIErrorFromDiscriminatorValue, createPaginatedResultOfImageWatermarkResponseFromDiscriminatorValue, type HttpValidationProblemDetails, type IError, type PaginatedResultOfImageWatermarkResponse } from '../models/index.js';
// @ts-ignore
import { type WithImageWatermarkItemRequestBuilder, WithImageWatermarkItemRequestBuilderNavigationMetadata, WithImageWatermarkItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type UploadRequestBuilder, UploadRequestBuilderNavigationMetadata } from './upload/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /image-watermarks
 */
export interface ImageWatermarksRequestBuilder extends BaseRequestBuilder<ImageWatermarksRequestBuilder> {
    /**
     * The upload property
     */
    get upload(): UploadRequestBuilder;
    /**
     * Gets an item from the ApiSdk.imageWatermarks.item collection
     * @param imageWatermarkId Unique identifier of the item
     * @returns {WithImageWatermarkItemRequestBuilder}
     */
     byImageWatermarkId(imageWatermarkId: Guid) : WithImageWatermarkItemRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PaginatedResultOfImageWatermarkResponse>}
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<ImageWatermarksRequestBuilderGetQueryParameters> | undefined) : Promise<PaginatedResultOfImageWatermarkResponse | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<ImageWatermarksRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
export interface ImageWatermarksRequestBuilderGetQueryParameters {
    page?: number;
    pageSize?: number;
}
/**
 * Uri template for the request builder.
 */
export const ImageWatermarksRequestBuilderUriTemplate = "{+baseurl}/image-watermarks{?page*,pageSize*}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ImageWatermarksRequestBuilderNavigationMetadata: Record<Exclude<keyof ImageWatermarksRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byImageWatermarkId: {
        requestsMetadata: WithImageWatermarkItemRequestBuilderRequestsMetadata,
        navigationMetadata: WithImageWatermarkItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["imageWatermarkId"],
    },
    upload: {
        navigationMetadata: UploadRequestBuilderNavigationMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const ImageWatermarksRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: ImageWatermarksRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPaginatedResultOfImageWatermarkResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
